/* Last labelled arrival in this tab; no email addresses stored. */
(function () {
  'use strict';
  var storageKey = 'orbicore.attribution.v1';
  var params = new URLSearchParams(window.location.search);
  var mapping = { OCSOURCE: 'utm_source', OCMEDIUM: 'utm_medium', OCCAMPAIGN: 'utm_campaign' };
  var defaults = { OCSOURCE: 'direct/unknown', OCMEDIUM: 'unknown', OCCAMPAIGN: '' };
  var values = Object.assign({}, defaults);
  function clean(value) {
    return typeof value === 'string' ? value.replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, 255) : '';
  }
  var labelled = Object.keys(mapping).some(function (key) { return clean(params.get(mapping[key])); });
  if (labelled) {
    Object.keys(mapping).forEach(function (key) { values[key] = clean(params.get(mapping[key])) || defaults[key]; });
    try { window.sessionStorage.setItem(storageKey, JSON.stringify(values)); } catch (_) {}
  } else {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(storageKey));
      if (saved && typeof saved === 'object') {
        Object.keys(mapping).forEach(function (key) { values[key] = clean(saved[key]) || defaults[key]; });
      }
    } catch (_) {}
  }
  function fill() {
    document.querySelectorAll('input[data-oc-attribution]').forEach(function (input) {
      if (Object.prototype.hasOwnProperty.call(values, input.name)) input.value = values[input.name];
    });
  }
  fill();
  document.addEventListener('shopify:section:load', fill);
  document.addEventListener('submit', function (event) {
    if (event.target.matches('form.oc-form')) fill();
  }, true);
}());
